const ALPHA_WITH_SPACES_VALIDATOR = (value, component) => {
    return /^[a-zA-Z\s]*$/.test(value);
};

const ALPHA_NUMERIC_WITH_SPACES_VALIDATOR = (value, component) => {
    return /^[a-zA-Z0-9\s]*$/.test(value);
};

export {
    ALPHA_WITH_SPACES_VALIDATOR,
    ALPHA_NUMERIC_WITH_SPACES_VALIDATOR
}